import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'atram-select',
  templateUrl: './atram-select.component.html',
  styleUrls: ['./atram-select.component.less']
})
export class AtramSelectComponent implements OnInit {

  @Input() parentFormGroup!: FormGroup;
  @Input() controlName: string = '';
  @Input() label:string = '';
  @Input() isRequired: boolean = false;
  @Input() isError: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input('upper-case') upperCase: boolean = false; // directive
  @Input() componentClass:string = '';
  @Input() options: Array<any> = [];
  @Output('on-select') onSelectEmitter: EventEmitter<any>;
  @Output('on-click') onClickEmitter: EventEmitter<any>;

  constructor() {
    this.onSelectEmitter = new EventEmitter<any>();
    this.onClickEmitter = new EventEmitter<void>();
  }

  ngOnInit() {
  }

  public onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.onClickEmitter.emit(event);
  }


  public onSelect(event: Event): void {
    let value: any = (event.target as HTMLSelectElement).value;
    this.onSelectEmitter.emit(this.upperCase ? value.toUpperCase() : value);
  }

}

